import { render } from "./ClientConfigOptionCreate.vue?vue&type=template&id=ceb57d6c"
import script from "./ClientConfigOptionCreate.vue?vue&type=script&lang=js"
export * from "./ClientConfigOptionCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__